import _ from 'lodash'

import { tours } from '../../api/api'

export const FETCH_DESTINATIONS_SUCCESS = 'FETCH_DESTINATIONS_SUCCESS'
export const FETCH_TOURS_BEGIN   = 'FETCH_TOURS_BEGIN'
export const FETCH_TOURS_SUCCESS = 'FETCH_TOURS_SUCCESS'
export const FETCH_TOURS_ERROR = 'FETCH_TOURS_ERROR'

export const fetchTours = () => (dispatch, getState) => {
  dispatch({ type: FETCH_TOURS_BEGIN })
  const brand = _.get(getState(), 'configurationData.data.brand')
  return tours(brand)
    .then(response => {
      dispatch({ type: FETCH_DESTINATIONS_SUCCESS, payload: _.get(response, 'destinations') })
      dispatch({ type: FETCH_TOURS_SUCCESS, payload: _.get(response, 'tours') })
    })
    .catch(error => dispatch({ type: FETCH_TOURS_ERROR, payload: true }))
}
